export default __webpack_public_path__ + "static/media/2223 cutlery side.4a08e45e.png";